import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/doi-tac/page-client.tsx");
